<template>
    <app-layout>
        <div>
            <page-header :title="trans('stakeholders.edit.header.title')" />
            <row>
                <column>
                    <jet-form-section type="decent" @submitted="handleSubmit">
                        <template #form>
                            <stakeholder-form-section :form="form" />
                        </template>
                        <template #actions>
                            <jet-form-buttons
                                :cancel-route="route('assets.show', asset)"
                                :disabled="!form.isDirty || form.processing"
                                :has-changes="form.isDirty"
                                :is-processing="form.processing"
                                :is-update-form="true"
                                @submit="handleSubmit"
                            />
                        </template>
                    </jet-form-section>
                </column>
            </row>
        </div>
    </app-layout>
</template>
<script setup>
import AppLayout from '@/Layouts/AppLayout.vue';
import JetFormSection from '@/Jetstream/FormSection.vue';
import JetFormButtons from '@/Jetstream/FormButtons.vue';
import PageHeader from '@/Components/PageHeader.vue';
import StakeholderFormSection from '@/Pages/Stakeholders/Components/StakeholderFormSection.vue';
import { useForm } from '@inertiajs/vue3';
import { route } from 'ziggy-js';

const props = defineProps({
    asset: Object,
});

const form = useForm({
    owners: props.asset.owners?.map((owner) => owner.id) || [],
    operators: props.asset.operators?.map((owner) => owner.id) || [],
    maintainers: props.asset.maintainers?.map((owner) => owner.id) || [],
});

const handleSubmit = () => {
    form.put(route('assets.stakeholders.update', props.asset));
};
</script>
